import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';
import { mediaquery } from 'shared/styles/styleFunctions';
import theme from 'shared/styles/themes';

export default css({
  backgroundColor: 'white',
  padding: '12px',
  borderBottom: `1px solid ${COLORS.NEUTRAL100}`,
  borderTop: `1px solid ${COLORS.NEUTRAL100}`,
  '.brief-creator-info': {
    '&__invited-creator': {
      textAlign: 'center',
      color: COLORS.NEUTRAL600,
      margin: '32px 0',
    },
    '&__header': {
      alignItems: 'start',
      justifyContent: 'space-between',
      marginBottom: '12px',
      flexDirection: 'column',
      [mediaquery.md]: {
        flexDirection: 'row',
      },
    },
    '&__name-pic-wrapper': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    '&__name-buttons': {
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      marginBottom: theme.space[3],
      alignItems: 'center',
    },
    '&__age-gender': {
      marginBottom: theme.space[3],
    },
    '&__name-badges': {
      alignItems: 'center',
    },
    '&__creator-name': {
      marginBottom: 0,
      textAlign: 'center',
      fontWeight: 600,
      letterSpacing: 0,
      lineHeight: 1.8,
      fontSize: '24px',
      marginRight: theme.space[3],
    },
    '&__admin-btn-group': {
      borderRadius: '3px',
      border: `1px solid ${COLORS.NEUTRAL300}`,
      width: '30px',
      height: '30px',
      alignContent: 'center',
      cursor: 'pointer',
    },
    '&__footer': {
      justifyContent: 'start',
    },
    '&__tags': {
      marginTop: theme.space[5],
    },
    '&__pic': {
      marginBottom: theme.space[4],
      justifyContent: 'space-between',
    },
    '&__asset-badge': {
      color: COLORS.ORANGE500,
      position: 'absolute',
      bottom: 0,
      right: '10px',
      fontSize: '30px',
    },
    '&__elite-badge': {
      color: COLORS.ORANGE300,
      position: 'absolute',
      bottom: 0,
      left: '10px',
      fontSize: '30px',
    },
    '&__application-pitch': {
      backgroundColor: COLORS.NEUTRAL50,
      borderBottomLeftRadius: '10px',
      borderBottomRightRadius: '10px',
      padding: theme.space[3],
    },
    '&__application-pitch-label': {
      backgroundColor: COLORS.NEUTRAL50,
      borderTopLeftRadius: '10px',
      borderTopRightRadius: '10px',
      paddingLeft: theme.space[3],
    },
    '&__view-profile-button': {
      marginRight: theme.space[3],
    },
  },
});
